import { Basic } from "../basic.ts";
import Pickr from '@simonwep/pickr';
import i18next from "i18next";

/**
 * @class MSColorPicker
 * @extends Basic
 * @classdesc Кнопка выбора цвета
 * */
export class MSColorPicker extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat(["colorselect"]);
    }

    constructor() {
        super();
        this.shRoot = this.attachShadow({ mode: "open" });
        this.shRoot.innerHTML = `
            <style>
                .pickr .pcr-button:before{background:url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path fill="white" d="M1,0H2V1H1V0ZM0,1H1V2H0V1Z"/><path fill="gray" d="M0,0H1V1H0V0ZM1,1H2V2H1V1Z"/></svg>');background-size:.5em;z-index:-1;z-index:auto}
                .pickr .pcr-button:after,.pickr .pcr-button:before{position:absolute;content:"";top:0;left:0;width:100%;height:100%;border-radius:.15em}
                .pickr .pcr-button:after{transition:background .3s;background:currentColor}
                .pickr .pcr-button.clear{background-size:70%}.pickr .pcr-button.clear:before{opacity:0}
                .pickr .pcr-button.clear:focus{box-shadow:0 0 0 1px hsla(0,0%,100%,.85),0 0 0 3px currentColor}
                .pickr .pcr-button.disabled{cursor:not-allowed}.pcr-app *,.pickr *{box-sizing:border-box;outline:none;border:none;-webkit-appearance:none}
                
                /* кастомные стили: */
                .pickr .pcr-button {
                    height: 100%;
                    width: 100%;
                }
            </style>

            <div style="width:100%; height:100%">
                <div id="color-picker"></div>
            </div>
        `;
        this._colorselect = this.getAttribute('colorselect') || "GRAY";
        this._pick = this.shRoot.getElementById("color-picker");
        this.pickr = new Pickr({
            el: this._pick,
            parent: window.__rootWin,
            theme: 'classic', // or 'monolith', or 'nano'
            default: this.colorselect,
            defaultRepresentation: "HEX",
            closeWithKey: "Escape",
            comparison: true,

            swatches: [
                "rgba(244, 67, 54, 1)",
                "rgba(233, 30, 99, 1)",
                "rgba(156, 39, 176, 1)",
                "rgba(103, 58, 183, 1)",
                "rgba(63, 81, 181, 1)",
                "rgba(33, 150, 243, 1)",
                "rgba(3, 169, 244, 1)",
                "rgba(0, 188, 212, 1)",
                "rgba(0, 150, 136, 1)",
                "rgba(76, 175, 80, 1)",
                "rgba(139, 195, 74, 1)",
                "rgba(205, 220, 57, 1)",
                "rgba(255, 235, 59, 1)",
                "rgba(255, 193, 7, 1)",
            ],

            components: {
                preview: true,
                opacity: true,
                hue: true,
                interaction: {
                    input: true,
                    save: true,
                },
            },
            i18n: {
                "btn:save": i18next.t('apply'),
            },
        });

        this.pickr.getRoot().button.style.color = this.colorselect

        this._setColor = e => {
            if (!e) return;
            const color = e.toRGBA().toString(0).replace(/\s+/g, "");
            this.SetParameter("colorselect", color, false, null, null, "",
                {
                    forced: true,
                });
            this.pickr.hide();
            if (this.onColorChange) this.onColorChange(e, color);

            const myCustomEvent = new CustomEvent('colorChange', {
                detail: {
                    color,
                },
                bubbles: false,
                cancelable: false,
            });
            this.dispatchEvent(myCustomEvent);
        };

        this.pickr.on("save", this._setColor);
        this.borderthickness = 0;
        this.backgroundcolor = "rgb(245,240,245)";
    }

    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._toBool(value);
        this.style.display = isShow ? "" : "none";
    }
    /**
     * Значение (выбор цвета)
     * @type {string}
     */
    get colorselect() {
        return this._colorselect;
    }
    set colorselect(value) {
        if(this._colorselect === value) return
        this.pickr.options.default = value;
        this.pickr.getRoot().button.style.color = value;
        this.pickr.setColor(value, true);

        this._colorselect = value;
    }

    get onColorChange() {
        return this._onColorChange;
    }

    set onColorChange(v) {
        this._onColorChange = v;
    }

    attributeChangedCallback(attrName, oldVal, newVal, itemIndex, callbackData) {
        this.attributeChangedCallbackInternal(attrName, oldVal, newVal, callbackData, "colorselect");
    }

    resetValueInternal() {
        if (this._rawValue != this.colorselect) {
            this.SetParameter("colorselect", this._rawValue, true);
        }
    }

    disconnectedCallback() {
        this.pickr.off("save", this._setColor);
        this.pickr.destroyAndRemove();
        this.pickr = null
        super.disconnectedCallback();
    }
}
